// extracted by mini-css-extract-plugin
export default {"container":"Home_container__rdxHF","content":"Home_content__sID3c","texto":"Home_texto__lPeaS","whatsapp":"Home_whatsapp__PNaFV"};